function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "social-linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    className: "social-circle",
    cx: 22,
    cy: 22,
    r: 22,
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "social-icon",
    d: "M33,32H28.14V25c0-1.84-.76-3.1-2.43-3.1a2.45,2.45,0,0,0-2.32,1.67,3.1,3.1,0,0,0-.1,1.11V32H18.47s.06-12.45,0-13.59h4.82v2.13c.29-.93,1.82-2.26,4.28-2.26,3,0,5.44,2,5.44,6.16V32h0ZM13.59,16.71h0A2.37,2.37,0,0,1,11,14.58v-.22a2.62,2.62,0,1,1,2.87,2.34h-.28Zm-2,1.7h4.29V32H11.55V18.41Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a153cf1644cdc2b8d8c83d2361f5c911.svg";
export { ForwardRef as ReactComponent };